import React from "react";
import { IStepper } from "../../interfaces/Components/Stepper/IStepper";

import "./Stepper.scss";

export const Stepper: React.FC<IStepper> = ({ steps, currentStep, ...props }) => {
  const renderSteps = () => steps.map((description: string, index: number) => {
    let className: string | null = index === currentStep ? "current" : null;
    if (index !== currentStep && index < currentStep) className = "complete";
    return className
      ? <li key={index} className={className}>{description}</li>
      : <li key={index}>{description}</li>;
  });

  const className = `stepper ${props.className || ""}`;
  return (
    <ul className={className}>
      {renderSteps()}
    </ul>
  );
};
